import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, byteSize, openFile } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './user-extra.reducer';

export const UserExtraDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const userExtraEntity = useAppSelector(state => state.userExtra.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="userExtraDetailsHeading">
          <Translate contentKey="factcheckingApp.userExtra.detail.title">UserExtra</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{userExtraEntity.id}</dd>
          <dt>
            <span id="title">
              <Translate contentKey="factcheckingApp.userExtra.title">Title</Translate>
            </span>
          </dt>
          <dd>{userExtraEntity.title}</dd>
          <dt>
            <span id="title2">
              <Translate contentKey="factcheckingApp.userExtra.title2">Title2</Translate>
            </span>
          </dt>
          <dd>{userExtraEntity.title2}</dd>
          <dt>
            <span id="position">
              <Translate contentKey="factcheckingApp.userExtra.position">Position</Translate>
            </span>
          </dt>
          <dd>{userExtraEntity.position}</dd>
          <dt>
            <span id="note">
              <Translate contentKey="factcheckingApp.userExtra.note">Note</Translate>
            </span>
          </dt>
          <dd>{userExtraEntity.note}</dd>
          <dt>
            <span id="signature">
              <Translate contentKey="factcheckingApp.userExtra.signature">Signature</Translate>
            </span>
          </dt>
          <dd>
            {userExtraEntity.signature ? (
              <div>
                {userExtraEntity.signatureContentType ? (
                  <a onClick={openFile(userExtraEntity.signatureContentType, userExtraEntity.signature)}>
                    <img
                      src={`data:${userExtraEntity.signatureContentType};base64,${userExtraEntity.signature}`}
                      style={{ maxHeight: '30px' }}
                    />
                  </a>
                ) : null}
                <span>
                  {userExtraEntity.signatureContentType}, {byteSize(userExtraEntity.signature)}
                </span>
              </div>
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="factcheckingApp.userExtra.user">User</Translate>
          </dt>
          <dd>{userExtraEntity.user ? userExtraEntity.user.login : ''}</dd>
        </dl>
        <Button tag={Link} to="/user-extra" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/user-extra/${userExtraEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UserExtraDetail;
